import React from 'react';
import './Navbar.css';
import logo from './Assets/logo.jpg'
import NavItems from './NavItems/NavItems'
import Button from '../UI/Button/Button';
import Harmburger from '../UI/Harmburger/Harmburger'

const Navbar = (props)=> {
    return(
        <div className="Navbar contain">
            <div className="Logo">
                <img className="img_contain" src={logo} alt="logo" />
            </div>
            <div className="Navbar_right">
                <NavItems />
                <div className="Nav_btn">
                    <Button clicked={props.joinNow} name="Join now"/>
                </div>
            </div>
            <Harmburger clicked={props.clickedHarmburger} />
        </div>
    )
}

export default Navbar